module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-schreibtisch-03.4b450b9a.jpeg";